import { render, staticRenderFns } from "./FaturamentoPrincipaisClientes3.vue?vue&type=template&id=6c9f78ae&scoped=true&"
import script from "./FaturamentoPrincipaisClientes3.vue?vue&type=script&lang=js&"
export * from "./FaturamentoPrincipaisClientes3.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoPrincipaisClientes3.vue?vue&type=style&index=0&id=6c9f78ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9f78ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
